<template>
  <top-nav>
    <li v-if="$can.view($store.getters.getAuthUser, 'bidbonds-reports')">
      <router-link
        :to="{ name: 'reports.bidbonds'}"
      >
        Bidbonds
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'companies-reports')">
      <router-link :to="{ name: 'reports.companies'}">
        Companies
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'bidbonds-reports')">
      <router-link :to="{ name: 'reports.bidbonds.payments'}">
        Bidbond Payments
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'view-leads')">
      <router-link :to="{ name: 'reports.tenders'}">
        Tender Leads
      </router-link>
    </li>
  </top-nav>
</template>
<script>
import TopNav from "@/components/TopNav.vue";

export default {
  components: {
    TopNav
  }
}
</script>
